import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SummariseNumberPipe } from './pipes/summarise-number.pipe';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { HeaderComponent } from 'src/app/shared/components/layout/header/header.component';
import { FooterComponent } from 'src/app/shared/components/layout/footer/footer.component';
import { RouterModule } from '@angular/router';
import { MarketListComponent } from 'src/app/shared/components/market-list/market-list.component';
import { DatePipe } from './pipes/date.pipe';
import { IRRToIRTPipe } from './pipes/irrto-irt.pipe';
import { FarsiToFinglishPipe } from './pipes/farsi-to-finglish.pipe';
import { FestivalPopupComponent } from './components/festival-popup/festival-popup.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PercentageComponent } from './components/percentage/percentage.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { ClickOutsideDirective } from './directives/click-outside.directive';

const SHARED_PIPES = [
  SummariseNumberPipe,
  DatePipe,
  FarsiToFinglishPipe,
  IRRToIRTPipe,
];
const SHARED_COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  SkeletonComponent,
  MarketListComponent,
  PercentageComponent,
  ClickOutsideDirective
];

@NgModule({
  declarations: [...SHARED_COMPONENTS, ...SHARED_PIPES, FestivalPopupComponent],
  imports: [CommonModule, RouterModule, MatDialogModule, OverlayModule],
  exports: [...SHARED_COMPONENTS, ...SHARED_PIPES],
})
export class SharedModule {}
